import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { recipes } from '../content/recipes';
import { knowledgeArticles } from '../content/knowledge';
import { magazineArticles } from '../content/magazine';

const GROUPS = [
  {
    heading: 'Hauptseiten',
    links: [
      { to: '/', label: 'Startseite' },
      { to: '/rezepte', label: 'Rezepte' },
      { to: '/wissen', label: 'Wissen' },
      { to: '/felix', label: 'Über Felix' },
      { to: '/magazin', label: 'Magazin' },
      { to: '/kontakt', label: 'Kontakt' },
    ],
  },
  {
    heading: 'Rezepte',
    links: recipes.map((r) => ({ to: `/rezepte/${r.slug}`, label: r.name })),
  },
  {
    heading: 'Wissensartikel',
    links: knowledgeArticles.map((a) => ({ to: `/wissen/${a.slug}`, label: a.title })),
  },
  {
    heading: 'Magazinartikel',
    links: magazineArticles.map((a) => ({ to: `/magazin/${a.slug}`, label: a.title })),
  },
  {
    heading: 'Rechtliches',
    links: [
      { to: '/impressum', label: 'Impressum' },
      { to: '/datenschutz', label: 'Datenschutz' },
      { to: '/barrierefreiheit', label: 'Barrierefreiheit' },
    ],
  },
];

export default function Sitemap() {
  return (
    <>
      <Seo title="Sitemap | Felix Genuss" description="Alle Seiten von Felix Genuss im Überblick: Rezepte, Wissen, Magazin und rechtliche Informationen." path="/sitemap" />
      <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Sitemap' }]} />
      <div className="container-site max-w-3xl pt-10">
        <h1 className="font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">Sitemap</h1>
        <p className="mt-6 leading-relaxed text-brand-brown/85">Alle Seiten von Felix Genuss im Überblick.</p>
        <div className="mt-10 space-y-10">
          {GROUPS.map((g) => (
            <nav key={g.heading} aria-label={`Sitemap: ${g.heading}`}>
              <h2 className="font-serif text-2xl font-bold">{g.heading}</h2>
              <ul className="mt-4 space-y-2">
                {g.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="link-inline">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </div>
    </>
  );
}
